import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';
import TextField from '@zenbusiness/zui/TextField';

export const TextInputStyled = styled(TextField)(({ theme }) => ({
  ' .MuiInputBase-root.Mui-focused .MuiInputAdornment-root .MuiTypography-root': {
    color: theme.palette.text.primary
  },

  ' .MuiInputBase-root': {
    backgroundColor: 'transparent'
  },

  ' .MuiInputBase-root .MuiInputBase-input': {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 900,
    fontSize: 96,
    lineHeight: '90px',
    letterSpacing: '-2px',
    [theme.breakpoints.down('md')]: {
      fontSize: 40,
      lineHeight: '40px'
    },
    userSelect: 'none'
  }
}));

export const BoxStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isDisable'
})(({ isDisable }) => ({
  opacity: isDisable ? 0.5 : 1
}));
